import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ComponiFatturaPRSummaryComponent } from './componi-fattura-pr-summary';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.componi-fattura-pr-summary', {
            url: '/componi-fattura-pr-summary',
            ncyBreadcrumb: {
                label: 'Componi Fattura Riepilogo',
                parent: 'home.fatturazione-pr'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Componi Fattura Riepilogo'
            },
            'views': {
                'homeContent': {
                    template: '<componi-fattura-pr-summary flex="100"></componi-fattura-pr-summary>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ComponiFatturaPRSummaryModule: string = ng
    .module('componi-fattura-pr-summary', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('componiFatturaPrSummary', ComponiFatturaPRSummaryComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/componi-fattura-pr-summary/componi-fattura-pr-summary.module.ts